
import Main from "@/views/Main.vue";

const customerRoutes = [
  {
    path: "/aftersale",
    icon: "key",
    title: "售后商品管理",
    name: "aftersale",
    component: Main,
    children: [
      {
        path: "layeredConfig",
        title: "售后商品分层配置",
        name: "layeredConfig",
        component: resolve => {
          require(["@/views/aftersale/layeredConfig.vue"], resolve);
        }
      },
    ]
  },
]

export default customerRoutes
